import projection from '../generated/pwd206f1.json';
import { AcceptanceManifest } from '../types';
export const pwd206f1AcceptanceManifest = projection as AcceptanceManifest;
